<template>
  <div :class="styles.panel">
    <header :class="styles.header">
      <h1 :class="styles.title">{{ $t('客服中心') }}</h1>
      <button type="button" :class="styles.closeIcon" @click="emit('close')">
        <SvgIcon name="svg/close.svg" :class="styles.x" size="28px" />
      </button>
    </header>

    <div :class="styles.contentWrapper">
      <Transition name="panel-switch" mode="out-in">
        <component
          :is="panelType === PANEL_TYPE.Customer ? CustomerPanel : FeedbackPanel"
          :key="panelType"
          @close-panel="emit('close')" />
      </Transition>
    </div>

    <nav :class="styles.footer">
      <button
        type="button"
        :class="[styles.tab, { [styles.tabActive]: panelType === PANEL_TYPE.Customer }]"
        @click="switchPanelType(PANEL_TYPE.Customer)">
        <SvgIcon name="svg/cs_livechat.svg" :class="styles.tabIcon" />
        <span>{{ $t('在线客服') }}</span>
      </button>
      <button
        type="button"
        :class="[styles.tab, { [styles.tabActive]: panelType === PANEL_TYPE.Feedback }]"
        @click="switchPanelType(PANEL_TYPE.Feedback)">
        <SvgIcon name="svg/cs_feedback.svg" :class="styles.tabIcon" />
        <span>{{ $t('意见反馈') }}</span>
      </button>
      <RouterLink to="/feedback" :class="styles.tab" @click="emit('close')">
        <SvgIcon name="svg/cs_myfeedback.svg" :class="styles.tabIcon" />
        <span>{{ $t('我的反馈') }}</span>
      </RouterLink>
    </nav>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import CustomerPanel from './CustomerPanel.vue'
import FeedbackPanel from './FeedbackPanel.vue'
import SvgIcon from '@/components/SvgIcon.vue'
import { PANEL_TYPE, type PanelType } from '@/types/service.ts'
// 外部传参数定位到对应tab 暂时没有用
const props = withDefaults(
  defineProps<{
    type: PanelType
  }>(),
  {
    type: PANEL_TYPE.Customer
  }
)

const emit = defineEmits<{ close: [] }>()
const panelType = ref<PanelType>(props.type)

const switchPanelType = (type: PanelType) => {
  panelType.value = type
}
</script>

<style lang="scss" module="styles">
.panel {
  display: flex;
  flex-direction: column;
  width: 430px;
  height: 700px;
  max-height: 100%;
  border-radius: 16px;
  overflow-y: auto;
  background: linear-gradient(180deg, #131312 0%, #161514 100%);
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.6);
}

.header {
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  height: 76px;
  padding: 0 20px;
  background: #211f1b;
}

.title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 22px;
  color: #e8ba6e;
}

.closeIcon {
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 5px;
  border: none;
  background: none;
  cursor: pointer;
}

.x {
  width: 20px;
  height: 20px;
  color: #e8ba6e;
  font-size: 20px;
}

.contentWrapper {
  display: flex;
  flex: 1;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.6);
}

.footer {
  position: sticky;
  bottom: 0;
  z-index: 1;
  display: flex;
  flex-shrink: 0;
  height: 75px;
  background: rgba(0, 0, 0, 0.2);
}

.tab {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  border: none;
  background: #22201e;
  color: #fff;
  font-size: 14px;
  line-height: 22px;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #2a2825;
  }
}

.tabActive {
  background: #34312e;

  &:hover {
    background: #34312e;
  }

  .tabIcon {
    font-size: 22px;
    color: #e8ba6e;
  }
}

.tabIcon {
  width: 30px;
  height: 30px;
  font-size: 20px;
  color: #635e59;
}

:global(.panel-switch-enter-active),
:global(.panel-switch-leave-active) {
  transition:
    opacity 0.25s ease,
    transform 0.25s ease;
}
:global(.panel-switch-enter-from),
:global(.panel-switch-leave-to) {
  opacity: 0;
  transform: translateY(8px);
}
</style>
